import React from 'react';
import { baseUrl } from '@capcenter/shared';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ContactUs from './ContactUs';
import MDColumbia from "./locations/MDColumbia";
import NCCary from "./locations/NCCary";
import NCCharlotte from "./locations/NCCharlotte";
import NCGreensboro from "./locations/NCGreensboro";
import SCCharleston from "./locations/SCCharleston";
import SCColumbia from "./locations/SCColumbia";
import SCGreenville from "./locations/SCGreenville";
import VAGlenAllen from "./locations/VAGlenAllen";
import VAMcLean from "./locations/VAMcLean";
import VAVirginiaBeach from "./locations/VAVirginiaBeach";
import VARichmond from "./locations/VARichmond";
import StateVA from "./locations/StateVA";
import StateFL from "./locations/StateFL";
import StateGA from "./locations/StateGA";
import StateSC from "./locations/StateSC";
import StateNC from "./locations/StateNC";
import StateMD from "./locations/StateMD";
import StateDC from "./locations/StateDC";
import DCWashington from "./locations/DCWashington";

function App() {
  return (
    <Router basename={'/contact'}>
      <Switch>
        <Route
          path={`/`}
          exact
          render={() => (
            <ContactUs />
          )}
        />
        <Route
          path={`/best-realty-columbia-md`}
          render={() => (
            <MDColumbia
              custom={{
                "code": "columbia-md",
                "city": "Columbia",
                "county": "Howard",
                "state": "MD",
                "title": "CapCenter Realty in Columbia, Maryland",
                "metaTitle": "Best real estate agency near me in Columbia, MD for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-columbia-md",
                "description": "Best real estate brokerage near me in Columbia, MD for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Columbia, MD for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "cap realty, agency, brokerage, best realtors, top realtors, agent, team, columbia, howard, howard county, baltimore, maryland, five star, 5 star",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-columbia-md`}
          render={() => (
            <MDColumbia
              custom={{
                "code": "columbia-md",
                "city": "Columbia",
                "county": "Howard",
                "state": "MD",
                "title": "CapCenter Mortgage in Columbia, Maryland",
                "metaTitle": "Best mortgage home loan lender near me in Columbia, MD for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-columbia-md",
                "description": "Best mortgage lender near me in Columbia, MD for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Columbia, MD for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "cap mortgage, best mortgage, top mortgage, low fee, waive, no closing costs, home loan, five star, 5 star",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />
        <Route
          path={`/best-realty-cary-nc`}
          render={() => (
            <NCCary
              custom={{
                "code": "cary-nc",
                "city": "Cary",
                "county": "Wake",
                "state": "NC",
                "title": "CapCenter Realty in Cary, North Carolina",
                "metaTitle": "Best real estate agency near me in Cary, NC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-cary-nc",
                "description": "Best real estate company near me in Cary, NC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Cary, NC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "cap realty, agency, brokerage, best realtors, top realtors, agent, team, cary, nc, wake county, raleigh, durham, five star, 5 star",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-cary-nc`}
          render={() => (
            <NCCary
              custom={{
                "code": "cary-nc",
                "city": "Cary",
                "county": "Wake",
                "state": "NC",
                "title": "CapCenter Mortgage in Cary, North Carolina",
                "metaTitle": "Best mortgage home loan lender near me in Cary, NC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-cary-nc",
                "description": "Best mortgage lender near me in Cary, NC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Cary, NC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "cap mortgage, best mortgage, top mortgage, low fee, waive, no closing costs, home loan, raleigh, durham, wake county, five star, 5 star",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />
        <Route
          path={`/best-realty-charlotte-nc`}
          render={() => (
            <NCCharlotte
              custom={{
                "code": "charlotte-nc",
                "city": "Charlotte",
                "county": "Mecklenburg",
                "state": "NC",
                "title": "CapCenter Realty in Charlotte, North Carolina",
                "metaTitle": "Best real estate agency near me in Charlotte, NC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-charlotte-nc",
                "description": "Best real estate company near me in Charlotte, NC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Charlotte, NC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "cap realty, agency, brokerage, best realtors, top realtors, agent, team, charlotte, mecklenburg, north carolina, nc, five star, 5 star",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-charlotte-nc`}
          render={() => (
            <NCCharlotte
              custom={{
                "code": "charlotte-nc",
                "city": "Charlotte",
                "county": "Mecklenburg",
                "state": "NC",
                "title": "CapCenter Mortgage in Charlotte, North Carolina",
                "metaTitle": "Best mortgage home loan lender near me in Charlotte, NC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-charlotte-nc",
                "description": "Best mortgage lender near me in Charlotte, NC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Charlotte, NC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "cap mortgage, best mortgage, top mortgage, low fee, waive, no closing costs, home loan, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />
        <Route
          path={`/best-realty-greensboro-nc`}
          render={() => (
            <NCGreensboro
              custom={{
                "code": "greensboro-nc",
                "city": "Greensboro",
                "county": "Guilford",
                "state": "NC",
                "title": "CapCenter Realty in Greensboro, North Carolina",
                "metaTitle": "Best real estate agency near me in Greensboro, NC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-greensboro-nc",
                "description": "Best real estate company near me in Greensboro, NC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Greensboro, NC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "cap realty, agency, brokerage, best realtors, top realtors, agent, team, greensboro, north carolina, guilford, five star, 5 star",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-greensboro-nc`}
          render={() => (
            <NCGreensboro
              custom={{
                "code": "greensboro-nc",
                "city": "Greensboro",
                "county": "Guilford",
                "state": "NC",
                "title": "CapCenter Mortgage in Greensboro, North Carolina",
                "metaTitle": "Best mortgage home loan lender near me in Greensboro, NC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-greensboro-nc",
                "description": "Best mortgage lender near me in Greensboro, NC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Greensboro, NC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "cap mortgage, best mortgage, gma, low fee, waive, no closing costs, home loan, greensboro, north carolina, guilford, five star, 5 star",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />
        <Route
          path={`/best-realty-charleston-sc`}
          render={() => (
            <SCCharleston
              custom={{
                "code": "charleston-sc",
                "city": "Charleston",
                "county": "Charleston",
                "state": "SC",
                "title": "CapCenter Realty in Charleston, South Carolina",
                "metaTitle": "Best real estate agency near me in Charleston, SC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-charleston-sc",
                "description": "Best real estate company near me in Charleston, SC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Charleston, SC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "cap realty, agency, brokerage, best realtors, top realtors, agent, team, charleston, south carolina, sc, five star, 5 star",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-charleston-sc`}
          render={() => (
            <SCCharleston
              custom={{
                "code": "charleston-sc",
                "city": "Charleston",
                "county": "Charleston",
                "state": "SC",
                "title": "CapCenter Mortgage in Charleston, South Carolina",
                "metaTitle": "Best mortgage home loan lender near me in Charleston, SC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-charleston-sc",
                "description": "Best mortgage lender near me in Charleston, SC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Charleston, SC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "cap mortgage, best mortgage, top mortgage, low fee, waive, no closing costs, home loan, charleston, south carolina",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />
        <Route
          path={`/best-realty-columbia-sc`}
          render={() => (
            <SCColumbia
              custom={{
                "code": "columbia-sc",
                "city": "Columbia",
                "county": "Columbia",
                "state": "SC",
                "title": "CapCenter Realty in Columbia, South Carolina",
                "metaTitle": "Best real estate agency near me in Columbia, SC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-charleston-sc",
                "description": "Best real estate company near me in Columbia, SC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Columbia, SC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "cap realty, agency, brokerage, best realtors, top realtors, agent, team, columbia, south carolina, sc, five star, 5 star",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-columbia-sc`}
          render={() => (
            <SCColumbia
              custom={{
                "code": "columbia-sc",
                "city": "Columbia",
                "county": "Columbia",
                "state": "SC",
                "title": "CapCenter Mortgage in Columbia, South Carolina",
                "metaTitle": "Best mortgage home loan lender near me in Columbia, SC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-columbia-sc",
                "description": "Best mortgage lender near me in Columbia, SC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Columbia, SC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "cap mortgage, best mortgage, top mortgage, low fee, waive, no closing costs, home loan, columbia, south carolina",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />
        <Route
          path={`/best-realty-greenville-sc`}
          render={() => (
            <SCGreenville
              custom={{
                "code": "greenville-sc",
                "city": "Greenville",
                "county": "Greenville",
                "state": "SC",
                "title": "CapCenter Realty in Greenville, South Carolina",
                "metaTitle": "Best real estate agency near me in Greenville, SC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-greenville-sc",
                "description": "Best real estate company near me in Greenville, SC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Greenville, SC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "cap realty, agency, brokerage, best realtors, top realtors, agent, team, greenville, south carolina, sc, five star, 5 star",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-greenville-sc`}
          render={() => (
            <SCGreenville
              custom={{
                "code": "greenville-sc",
                "city": "Greenville",
                "county": "Greenville",
                "state": "SC",
                "title": "CapCenter Mortgage in Greenville, South Carolina",
                "metaTitle": "Best mortgage home loan lender near me in Greenville, SC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-greenville-sc",
                "description": "Best mortgage lender near me in Greenville, SC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Greenville, SC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "cap mortgage, best mortgage, top mortgage, low fee, waive, no closing costs, home loan, greenville, sc, five star, 5 star",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />
        <Route
          path={`/best-realty-glen-allen-va`}
          render={() => (
            <VAGlenAllen
              custom={{
                "code": "glen-allen-va",
                "city": "Glen Allen",
                "county": "Henrico",
                "state": "VA",
                "title": "CapCenter Realty in Glen Allen, Virginia",
                "metaTitle": "Best real estate agency near me in Glen Allen, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-glen-allen-va",
                "description": "Best real estate company near me in Glen Allen, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Glen Allen, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "cap realty, agency, brokerage, best realtors, top realtors, agent, team, glen allen, innsbrook, virginia, va, henrico, five star, 5 star",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-glen-allen-va`}
          render={() => (
            <VAGlenAllen
              custom={{
                "code": "glen-allen-va",
                "city": "Glen Allen",
                "county": "Henrico",
                "state": "VA",
                "title": "CapCenter Mortgage in Glen Allen, Virginia",
                "metaTitle": "Best mortgage home loan lender near me in Glen Allen, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-glen-allen-va",
                "description": "Best mortgage lender near me in Glen Allen, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Glen Allen, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "cap mortgage, best mortgage, top mortgage, low fee, waive, no closing costs, home loan, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />
        <Route
          path={`/best-realty-mclean-va`}
          render={() => (
            <VAMcLean
              custom={{
                "code": "mclean-va",
                "city": "McLean",
                "county": "Fairfax",
                "state": "VA",
                "title": "CapCenter Realty in McLean, Virginia",
                "metaTitle": "Best real estate agency near me in McLean, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-mclean-va",
                "description": "Best real estate company near me in McLean, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in McLean, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "Best realty near me in nova, top realty in nova, mclean, fairfax, northern virginia, nova, five star, 5 star, reputation",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-mclean-va`}
          render={() => (
            <VAMcLean
              custom={{
                "code": "mclean-va",
                "city": "McLean",
                "county": "Fairfax",
                "state": "VA",
                "title": "CapCenter Mortgage in McLean, Virginia",
                "metaTitle": "Best mortgage home loan lender near me in McLean, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-mclean-va",
                "description": "Best mortgage lender near me in McLean, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in McLean, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "best mortgage in mclean, top mortgage in mclean, low fee, waive, no closing costs, nova, home loan, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />

        <Route
          path={`/best-realty-richmond-va`}
          render={() => (
            <VARichmond
              custom={{
                "code": "richmond-va",
                "city": "Richmond",
                "county": "Richmond",
                "state": "VA",
                "title": "CapCenter Realty in Richmond, Virginia",
                "metaTitle": "Best real estate agency near me in Richmond, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-richmond-va",
                "description": "Best real estate company near me in Richmond, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Richmond, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "Best realty near me in rva, top realty in rva, richmond, rva, virginia, va, five star, 5 star, reputation",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-richmond-va`}
          render={() => (
            <VARichmond
              custom={{
                "code": "richmond-va",
                "city": "Richmond",
                "county": "Richmond",
                "state": "VA",
                "title": "CapCenter Mortgage in Richmond, Virginia",
                "metaTitle": "Best mortgage home loan lender near me in Richmond, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-richmond-va",
                "description": "Best mortgage lender near me in Richmond, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Richmond, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "best mortgage in rva, top mortgage in rva, low fee, waive, no closing costs, home loan, rva, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />
        <Route
          path={`/best-realty-virginia-beach-va`}
          render={() => (
            <VAVirginiaBeach
              custom={{
                "code": "virginia-beach-va",
                "city": "Virginia Beach",
                "county": "Virginia Beach",
                "state": "VA",
                "title": "CapCenter Realty in Virginia Beach, Virginia",
                "metaTitle": "Best real estate agency near me in Virginia Beach, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-virginia-beach-va",
                "description": "Best real estate company near me in Virginia Beach, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Virginia Beach, VA for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "Best realty near me in va beach, top realty in va beach, virginia beach, virginia, va, five star, 5 star, reputation",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-virginia-beach-va`}
          render={() => (
            <VAVirginiaBeach
              custom={{
                "code": "virginia-beach-va",
                "city": "Virginia Beach",
                "county": "Virginia Beach",
                "state": "VA",
                "title": "CapCenter Mortgage in Virginia Beach, Virginia",
                "metaTitle": "Best mortgage home loan lender near me in Virginia Beach, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-virginia-beach-va",
                "description": "Best mortgage lender near me in Virginia Beach, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Virginia Beach, VA for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "best mortgage in virginia beach, top mortgage in virginia beach, low fee, waive, no closing costs, home loan, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />

        <Route
          path={`/best-realty-washington-dc`}
          render={() => (
            <DCWashington
              custom={{
                "code": "washington-dc",
                "city": "Washington",
                "state": "DC",
                "title": "CapCenter Realty in Washington, DC",
                "metaTitle": "Best real estate agency near me in Washington, DC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997",
                "url": "/contact/best-realty-washington-dc",
                "description": "Best real estate company near me in Washington, DC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "metaDescription": "Best real estate agents near me in Washington, DC for Cap Your Closing Costs® Zero Closing Cost purchases and 1% Listing Fee bundle established in 1997.",
                "keywords": "Best realty near me in dc, top realty in dc, dc, five star, 5 star, reputation",
                "isRealty": true,
                "isMortgage": false
              }}
            />
          )}
        />
        <Route
          path={`/best-mortgage-washington-dc`}
          render={() => (
            <StateDC
              custom={{
                "code": "washington-dc",
                "state": "DC",
                "stateLongName": "Washington, DC",
                "title": "CapCenter Mortgage in Washington DC",
                "metaTitle": "Best mortgage home loan lender near me in the Washington DC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-washington-dc",
                "description": "Best mortgage lender near me in Washington DC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Washington DC for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "best mortgage in dc, top mortgage in dc, low fee, waive, no closing costs, home loan, dmv, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />

        <Route
          path={`/best-mortgage-florida`}
          render={() => (
            <StateFL
              custom={{
                "code": "florida",
                "state": "FL",
                "stateLongName": "Florida FL",
                "title": "CapCenter Mortgage in Florida",
                "metaTitle": "Best mortgage home loan lender near me in the Florida for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-florida",
                "description": "Best mortgage lender near me in Florida for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Florida for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "best mortgage in fl, top mortgage in fl, low fee, waive, no closing costs, home loan, florida, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />

        <Route
          path={`/best-mortgage-georgia`}
          render={() => (
            <StateGA
              custom={{
                "code": "georgia",
                "state": "GA",
                "stateLongName": "Georgia GA",
                "title": "CapCenter Mortgage in Georgia",
                "metaTitle": "Best mortgage home loan lender near me in the Georgia for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-georgia",
                "description": "Best mortgage lender near me in Georgia for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Georgia for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "best mortgage in ga, top mortgage in ga, low fee, waive, no closing costs, home loan, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />

        <Route
          path={`/best-mortgage-maryland`}
          render={() => (
            <StateMD
              custom={{
                "code": "maryland",
                "state": "MD",
                "stateLongName": "Maryland MD",
                "title": "CapCenter Mortgage in Maryland",
                "metaTitle": "Best mortgage home loan lender near me in the Maryland for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-maryland",
                "description": "Best mortgage lender near me in Maryland for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Maryland for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "best mortgage in md, top mortgage in md, low fee, waive, no closing costs, home loan, maryland, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />

        <Route
          path={`/best-mortgage-north-carolina`}
          render={() => (
            <StateNC
              custom={{
                "code": "north-carolina",
                "state": "NC",
                "stateLongName": "North Carolina NC",
                "title": "CapCenter Mortgage in North Carolina",
                "metaTitle": "Best mortgage home loan lender near me in the North Carolina for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-north-carolina",
                "description": "Best mortgage lender near me in North Carolina for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in North Carolina for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "best mortgage in nc, top mortgage in nc, low fee, waive, no closing costs, home loan, north carolina, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />

        <Route
          path={`/best-mortgage-south-carolina`}
          render={() => (
            <StateSC
              custom={{
                "code": "south-carolina",
                "state": "SC",
                "stateLongName": "South Carolina SC",
                "title": "CapCenter Mortgage in South Carolina",
                "metaTitle": "Best mortgage home loan lender near me in the South Carolina for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-south-carolina",
                "description": "Best mortgage lender near me in South Carolina for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in South Carolina for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "best mortgage in sc, top mortgage in sc, low fee, waive, no closing costs, home loan, south carolina, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />

        <Route
          path={`/best-mortgage-virginia`}
          render={() => (
            <StateVA
              custom={{
                "code": "virginia",
                "state": "VA",
                "stateLongName": "Virginia VA",
                "title": "CapCenter Mortgage in Virginia",
                "metaTitle": "Best mortgage home loan lender near me in Virginia for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997",
                "url": "/contact/best-mortgage-virginia",
                "description": "Best mortgage lender near me in Virginia for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "metaDescription": "Best mortgage lender near me in Virginia for Cap Your Closing Costs® Zero Closing Cost home loans established in 1997.",
                "keywords": "best mortgage in va, top mortgage in va, low fee, waive, no closing costs, home loan, virginia, va, five star, 5 star, reputation",
                "isRealty": false,
                "isMortgage": true
              }}
            />
          )}
        />


        <Route
          path="*"
          component={() => {
            window.location.href = `${baseUrl}/404`;
            return null;
          }}
        />
      </Switch>
    </Router>
  );
}

export default App;
